const EditModes = {
  CREATE: 'create',
  UPDATE: 'update',
};

export default EditModes;
